module.exports = __webpack_public_path__ + "static/img/gx_mask.407534fe.png";